import { render, staticRenderFns } from "./ReviewCourse.vue?vue&type=template&id=917a99ca&scoped=true"
import script from "./ReviewCourse.vue?vue&type=script&lang=js"
export * from "./ReviewCourse.vue?vue&type=script&lang=js"
import style0 from "./ReviewCourse.vue?vue&type=style&index=0&id=917a99ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917a99ca",
  null
  
)

export default component.exports